import classNames from "shared/utils/classNames";
import { ReactComponent as IconResetChat } from "assets/images/icons/reset-chat.svg";

import { Props } from "./types";

function ButtonResetChatNonIframe(props: Props) {
  const {
    botInfo,
    resetChat,
    startAgainLabel,
    setIsResetChatModalOpen,
    className,
  } = props;

  return (
    <button
      className={classNames(
        "group absolute right-6 top-[-1px] border-none bg-transparent",
        className,
      )}
      onClick={() => {
        if (!botInfo.bot_info_config.show_post_chat_feedback) {
          return resetChat();
        }
        setIsResetChatModalOpen && setIsResetChatModalOpen(true);
      }}
    >
      <IconResetChat />
      <p className="absolute right-0 hidden w-16 rounded-lg bg-black px-2 py-1 text-white opacity-80 group-hover:block">
        {startAgainLabel}
      </p>
    </button>
  );
}

export default ButtonResetChatNonIframe;
